import { NAME_REGEX } from '@/features/profile-setting/constants/person';

export const isNameValid = (name: string) => NAME_REGEX.test(name);
